import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/css/professional-cleanup.css';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './Components/ErrorBoundary.js';
import ProtectedRoute from './Components/ProtectedRoute.js';
import Layout from './Components/Layout';
import AboutPage from './Components/AboutPage';
import Services from './Components/Services';
import Login from './Components/Login';
import Register from './Components/Register';
import Blog from './Components/Blog';
import Contact from './Components/Contact';
import Blogdetails from './Components/Blogdetails';
import Publication from './Components/Publication';
import ArticleList from './Components/Dashboard/ArticleList';
import EditArticle from './Components/Dashboard/EditArticle';
import CreateArticle from './Components/Dashboard/CreateArticle';
import Step1Form from './Components/Dashboard/step1form';
import Step2Form from './Components/Dashboard/step2form';
import Gallery from './Components/Gallery';
import AdminRoute from './Components/AdminRoute';
import GalleryAdmin from './Components/GalleryAdmin';
import CoursesPage from './Pages/LMS/CoursesPage';
import CourseDetailsPage from './Pages/LMS/CourseDetailsPage';
import StudentDashboardPage from './Pages/LMS/StudentDashboardPage';
import AdminDashboardPage from './Pages/LMS/AdminDashboardPage';
import VerifyCertificatePage from './Pages/LMS/VerifyCertificatePage';
import LearningPage from './Pages/LMS/LearningPage';
import VerifyEmailPage from './Pages/LMS/VerifyEmailPage';
import AdminCoursesPage from './Pages/LMS/Admin/AdminCoursesPage';
import AdminCreateCoursePage from './Pages/LMS/Admin/AdminCreateCoursePage';
import AdminEditCoursePage from './Pages/LMS/Admin/AdminEditCoursePage';
import AdminEnrollmentsPage from './Pages/LMS/Admin/AdminEnrollmentsPage';
import AdminUsersPage from './Pages/LMS/Admin/AdminUsersPage';
import SuperAdminPage from './Pages/LMS/Admin/SuperAdminPage';
import CompanyPage from './Pages/LMS/Admin/CompanyPage';
import AdminServicesPage from './Pages/LMS/Admin/AdminServicesPage';
import AdminCreateServicePage from './Pages/LMS/Admin/AdminCreateServicePage';
import AdminEditServicePage from './Pages/LMS/Admin/AdminEditServicePage';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Layout />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/trainings" element={<Navigate to="/courses" replace />} />
            <Route path="/trainings/:id" element={<Navigate to="/courses" replace />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/courses/:id" element={<CourseDetailsPage />} />
            <Route path="/verify-certificate/:code" element={<VerifyCertificatePage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route
              path="/student/dashboard"
              element={
                <ProtectedRoute>
                  <StudentDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/student/learning/:courseId"
              element={
                <ProtectedRoute>
                  <LearningPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/lms"
              element={
                <AdminRoute>
                  <AdminDashboardPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/courses"
              element={
                <AdminRoute>
                  <AdminCoursesPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/courses/create"
              element={
                <AdminRoute>
                  <AdminCreateCoursePage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/courses/edit/:id"
              element={
                <AdminRoute>
                  <AdminEditCoursePage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/lms-enrollments"
              element={
                <AdminRoute>
                  <AdminEnrollmentsPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <AdminRoute>
                  <AdminUsersPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/superadmin"
              element={
                <AdminRoute>
                  <SuperAdminPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/company"
              element={
                <AdminRoute>
                  <CompanyPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/services"
              element={
                <AdminRoute>
                  <AdminServicesPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/services/create"
              element={
                <AdminRoute>
                  <AdminCreateServicePage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/services/edit/:id"
              element={
                <AdminRoute>
                  <AdminEditServicePage />
                </AdminRoute>
              }
            />
            <Route path="/admin/enrollments" element={<Navigate to="/admin/lms-enrollments" replace />} />
            <Route path="/admin/trainings/create" element={<Navigate to="/admin/courses/create" replace />} />
            <Route path="/admin/trainings" element={<Navigate to="/admin/courses" replace />} />
            <Route path="/admin/trainings/edit/:id" element={<Navigate to="/admin/courses" replace />} />
            <Route path="/my-enrollments" element={<Navigate to="/student/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/blogd/:id" element={<Blogdetails />} />
            <Route path="/publication" element={<Publication />} />

            {/* Protected Routes */}
            <Route
              path="/alist"
              element={
                <ProtectedRoute>
                  <ArticleList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/create"
              element={
                <ProtectedRoute>
                  <CreateArticle />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit/:id"
              element={
                <ProtectedRoute>
                  <EditArticle />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gallery-admin"
              element={
                <ProtectedRoute>
                  <GalleryAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/articles/new"
              element={
                <ProtectedRoute>
                  <Step1Form />
                </ProtectedRoute>
              }
            />
            <Route
              path="/articles/step2/:id"
              element={
                <ProtectedRoute>
                  <Step2Form />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
